export function makeCategoryHref(subUrl: string) {
  const clean = subUrl.replace(/^\/+/, ""); // убираем ведущий /
  const slug = clean.split("/").join("_");  // все / -> _
  return `/catalog/${slug}`;                // добавляем обязательный /catalog
}
